import { format } from 'date-fns';

/**
 * Generate display text for shift coverage based on coverageType.
 * Returns { label, detail } or null if single-day with no extra info.
 */
export function getCoverageDisplay(shift) {
  const type = shift.coverageType || 'single_day';
  const days = shift.coverageDays || 1;

  if (type === 'single_day' || days <= 1) return null;

  if (type === 'date_range' && shift.endDate) {
    const startStr = formatShortDate(shift.date);
    const endStr = formatShortDate(shift.endDate);
    return {
      label: `${startStr} – ${endStr}`,
      detail: `${days} days`,
      full: `Cover: ${startStr} – ${endStr} (${days} days)`
    };
  }

  if (type === 'specific_dates' && shift.selectedDates && shift.selectedDates.length > 0) {
    const formatted = shift.selectedDates.map(d => formatShortDate(d));
    const label = formatted.length <= 3
      ? formatted.join(', ')
      : `${formatted.slice(0, 2).join(', ')} +${formatted.length - 2} more`;
    return {
      label,
      detail: `${days} dates`,
      full: `Cover: ${formatted.join(', ')} (${days} dates)`
    };
  }

  // Fallback for legacy shifts with just coverageDays > 1
  return {
    label: `${days} days`,
    detail: null,
    full: `Multi-day cover: ${days} days`
  };
}

function formatShortDate(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr + 'T00:00:00');
    return format(d, 'd MMM');
  } catch {
    return dateStr;
  }
}
